// extracted by mini-css-extract-plugin
export default {"imagePreview":"FontPreview-imagePreview-Vx6","dropdown":"FontPreview-dropdown-Viw","wrapper":"FontPreview-wrapper-une","action":"FontPreview-action-Fz4"};